import React from 'react';
import { Box, Card, CardContent, Typography } from '@mui/material';
import { BarChart } from '@mui/icons-material';
import { useThemeContext } from '../../hook/useThemeManager';
import { FONT_ENUM } from '../../types/global/fonts.types';
import { theme } from '../../constants/theme';

interface IEmptySection {
    header?: string;
    subHeader?: string;
    message?: string;
}

export const EmptySection: React.FC<IEmptySection> = ({ header, subHeader, message }) => {
    const { themeStyle } = useThemeContext();

    return (
        <Box>
            <Typography
                sx={{
                    fontFamily: FONT_ENUM.MAIN_BOLD,
                    fontSize: '1.25rem',
                    color: theme[themeStyle].primary_white,
                    mb: 3,
                }}>
                {header}
            </Typography>

            <Card
                sx={{
                    backgroundColor: theme[themeStyle].secondaryBg,
                    borderRadius: 2,
                    textAlign: 'center',
                    py: 6,
                }}>
                <CardContent>
                    <BarChart sx={{ fontSize: 64, color: theme[themeStyle].primary_white, mb: 2 }} />
                    <Typography
                        sx={{
                            fontFamily: FONT_ENUM.MAIN_BOLD,
                            fontSize: '1.5rem',
                            color: theme[themeStyle].primary_white,
                            mb: 1,
                        }}>
                        {subHeader}
                    </Typography>
                    <Typography
                        sx={{
                            fontFamily: FONT_ENUM.MAIN_REGULAR,
                            fontSize: '1rem',
                            color: theme[themeStyle].light_gray_text,
                            maxWidth: 500,
                            mx: 'auto',
                        }}>
                        {message}
                    </Typography>
                </CardContent>
            </Card>
        </Box>
    );
};

EmptySection.defaultProps = {
    header: 'Change header',
    message:
        "We're working on advanced analytics for your events. Soon you'll be able to track engagement, sales, revenue metrics, and more in this section.",
    subHeader: 'Section coming soon',
};
